<template lang="pug">
div
  .pa-2.mx-1.my-10
    v-row.my-10(justify="center")
      h2 Find your ideal EV with us
    v-row
      v-col
        HorizontalTripCard(
          :trip="trip",
          fromLabel="Where do you live?",
          toLabel="Where do you work?"
        )
    v-row(justify="center")
      v-col(cols=7, lg=3)
        v-row(justify="center")
          v-btn.primary(v-on:click="drivingDetails", block) Find my EV
        v-row.pa-4(justify="center")
          p Already own an EV?
        v-row(justify="center")
          v-btn.accent(v-on:click="routePlanning", block) Plan a trip
        v-row(justify="center")
          v-btn.accent.my-3(v-on:click="sharedTrips", block) See EV Owner Stories

    v-row(align="center", justify="end")
      v-col(cols=3)
        v-spacer
        em(style="font-size: 0.8em;margin-left:5px;") Powered by
        v-img(src="https://powersell.appstack.me/logo.png", width=100)
</template>

<script>
import HorizontalTripCard from "../components/HorizontalTripCard";
import Vue from 'vue';
export default {
  components: { HorizontalTripCard },
  data() {
    return {
      trip: {
        id: 1,
        title: "Commute",
        frequency: 1,
        frequencyUnit: "workday",
        viaAddresses: [],
        fromAddress: { Address: null },
        toAddress: { Address: null },
        path: [],
      },
    };
  },
  mounted() {
    this.$bubble.kms =0;
    if (this.$route.query.state) {
      let state = this.$route.query.state;
      let loadState = this.loadState;
      setTimeout(function () {
        loadState(state);
      }, 1000);
    }
        Vue.prototype.$Countly.q.push([
      "add_event",
      {
        key: "Bubble Landing Page",
        segmentation: {
          dealer: this.$dealer.default_settings.name,
        },
      },
    ]);
  },
  methods: {
    makeReturn(trip) {
      let newTrip = JSON.parse(JSON.stringify(trip));
      console.log(trip);
      newTrip.viaAddresses = newTrip.viaAddresses.reverse();
      let from = newTrip.fromAddress;
      newTrip.fromAddress = newTrip.toAddress;
      newTrip.toAddress = from;
      let index = this.$trips.findIndex(function (value) {
        return trip.id == value.id;
      });
      newTrip.id = 101 + trip.id;
      this.$trips.splice(index + 1, 0, newTrip);
    },
    drivingDetails() {
      this.$trips.push(this.trip);
      this.$bubble.location = this.trip.fromAddress;
      this.makeReturn(this.trip);
      this.$bubble.savingsMode = "trips";

      this.$router.push("recommender/2");
    },
    routePlanning() {
      this.$router.push("planner");
    },
    regularTrips() {
      this.$router.push("recommender/1");
    },
    sharedTrips() {
      this.$router.push("road-trips");
    },
    dealerAdmin() {
      this.$router.push("dealer");
    },
  },
};
</script>

<style scoped>
.v-card > h2,
.subtitle {
  color: #1e88e5;
  font-weight: bold;
}
a {
  text-decoration: none;
}
.right {
  float: right;
}
.v-card p {
  text-align: center;
}
.v-card .v-image {
  transform: translate(-50%, 0);
  left: 50%;
  opacity: 0.6;
}
.icon-image {
  opacity: 0.5;
  float: right;
}
.white {
  filter: invert(1);
  mix-blend-mode: lighten;
}
</style>